import { LaunchesDate } from "@oldDashboard/legacyModels/launchesDate.model";
import { LaunchesDateSerializer } from "@oldDashboard/legacyModels/serializers/launchesDateSerializer";
import { legacyReportingGet } from "@oldDashboard/legacyUtils";
export class CommandLaunchDate {

    async run(launchSelected: String, timePeriodSelected: String) {
        const path = `get-chart-data/client:time-period-dates/?launch_id=${launchSelected}&time_period=${timePeriodSelected}`
        try {
            const response = await legacyReportingGet(path);
            if (response.success) {
                const data =  response.chart_data.data_points;
                if(data.length == 1) {
                    data.push({
                        name: "",
                        y: "0",
                        color: "#699cfc"
                    });
                }
                const aux = [].concat(data).reverse();
                return this.deserialize(aux);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }

    deserialize(data: any) : LaunchesDate[] {
        const serializer = new LaunchesDateSerializer();
        return serializer.deserializeList(data);
    }
}

